<template>
    <div v-if="isRowVisible" class="d-flex no-gutters" :class="dynamicClasses" :style="rowStyle">
        <column-renderer v-for="(column, columnIndex) in row.columns"
                         :row="row"
                         :column="column"
                         :index="index"
                         :key="index + columnIndex + 'Column'"
                         :layout="layout"
                         :document="document"
                         :table="table"
                         :view="view"></column-renderer>
    </div>
</template>

<script>
    import ColumnRenderer from "./ColumnRenderer.vue";
    import ConditionFactory from "../../conditions/ConditionFactory";

    export default {
        name: 'RowRenderer',
        components: {ColumnRenderer},
        props: ['layout', 'row', 'index', 'document', 'table', 'view'],
        computed: {
            hasConditions() {
                return this.row.conditions && this.row.conditions.length > 0
            },
            currentDocuments() {
                return this.model.documents
            },
            conditions() {
                return this.row.conditions
            },
            isRowVisible() {
                if (!this.hasConditions) {
                    return true
                }

                let conditionFactory = new ConditionFactory(this.conditions, this.currentDocuments)
                let conditionTest = conditionFactory.test()
                return conditionTest
            },
            rowStyle() {
                if (this.hasBgImage) {
                    return {
                        ...this.baseStyle,
                        ...this.bgImageStyle
                    }
                }

                if (this.hasFieldBgImage) {
                    return {
                        ...this.baseStyle,
                        ...this.fieldBgImageStyle
                    }
                }

                // if( this.hasBgPattern ) {
                //     return {
                //         minHeight: this.row.minHeight ? this.row.minHeight + 'px' : 'inherit',
                //         ...this.bgPatternStyle
                //     }
                // }

                return {
                    ...this.baseStyle,
                    ...this.colorStyle
                }
            },
            baseStyle() {
                return {
                    color: this.row.color ? this.row.color : '#000000',
                    minHeight: this.row.minHeight ? this.row.minHeight + 'px' : 'inherit'
                }
            },
            colorStyle() {
                if(this.row.background.type === 'none') {
                    return {}
                }

                return {
                    backgroundColor: this.row.background && this.row.background.color ? this.row.background.color : '#FFFFFF'
                }
            },
            bgImageStyle() {
                let imageUrl = this.row.background.image.url
                return {
                    'background-image': `url(${imageUrl})`
                }
            },
            fieldBgImageStyle() {
                let imageUrl = this.bgImageFromField.url

                return {
                    'background-image': `url(${imageUrl})`
                }
            },
            dynamicClasses() {
                let baseClasses = this.marginClass + ' ' + this.paddingClass

                if (this.hasBgImage || this.hasFieldBgImage) {
                    baseClasses += ' row-image-background'
                }
                // else if(this.hasBgPattern) {
                //     baseClasses += (' ' + this.bgPatternClass)
                // }

                return baseClasses.trim()
            },
            hasFieldBgImage() {
                let background = this.row.background
                return !!(background && background.field_id && this.bgImageFromField)
            },
            bgImageFromField() {
                let background = this.row.background
                let field = webase.utils.array.get(this.table.fields, background.field_id)
                return this.document[field.index]
            },
            hasBgImage() {
                let background = this.row.background
                return !!(background && background.type === 'image' && background.image)
            },
            marginClass() {
                if (!this.row.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.row.margin)
            },
            paddingClass() {
                if (!this.row.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.row.padding)
            },
        },
        data() {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
